import React from "react";

export default function Loader({
  text = "Loading...",
  fullScreen = false,
  size = "md",
}) {
  const sizes = {
    sm: "h-5 w-5 border-2",
    md: "h-8 w-8 border-[3px]",
    lg: "h-12 w-12 border-4",
  };

  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen ? "min-h-screen w-full" : "min-h-[200px] w-full"
      }`}
    >
      <div className="flex flex-col items-center gap-3">
        {/* Animated Spinner */}
        <div className="relative">
          <div
            className={`${sizes[size]} rounded-full border-slate-200`}
          />

          <div
            className={`absolute inset-0 ${sizes[size]} animate-spin rounded-full border-transparent border-t-slate-800`}
          />
        </div>

        {/* Loading Text */}
        {text && (
          <p className="animate-pulse text-[13px] font-medium text-slate-500">
            {text}
          </p>
        )}
      </div>
    </div>
  );
}